export interface SubscriptionRedirectContext {
  from?: string
  videoId?: string
  videoTitle?: string
  videoThumbnail?: string
  videoProvider?: string
  sectionTitle?: string
  tagId?: string
  tagName?: string
}

const sanitizeValue = (value?: string | null): string | undefined => {
  if (!value) {
    return undefined
  }
  return value.trim().slice(0, 400)
}

export const buildSubscriptionUrl = (context: SubscriptionRedirectContext = {}): string => {
  const params = new URLSearchParams()

  const from = sanitizeValue(context.from) || 'generic'
  params.set('from', from)

  const id = sanitizeValue(context.videoId)
  if (id) {
    params.set('id', id)
  }

  const title = sanitizeValue(context.videoTitle)
  if (title) {
    params.set('title', title)
  }

  const thumbnail = sanitizeValue(context.videoThumbnail)
  if (thumbnail) {
    params.set('thumb', thumbnail)
  }

  const provider = sanitizeValue(context.videoProvider)
  if (provider) {
    params.set('provider', provider)
  }

  const section = sanitizeValue(context.sectionTitle)
  if (section) {
    params.set('section', section)
  }

  const tagId = sanitizeValue(context.tagId)
  if (tagId) {
    params.set('tagId', tagId)
  }

  const tagName = sanitizeValue(context.tagName)
  if (tagName) {
    params.set('tagName', tagName)
  }

  const queryString = params.toString()
  return queryString ? `/subscriptions?${queryString}` : '/subscriptions'
}

export const parseSubscriptionIntent = (search: string): SubscriptionRedirectContext => {
  const params = new URLSearchParams(search)

  return {
    from: params.get('from') || undefined,
    videoId: params.get('id') || undefined,
    videoTitle: params.get('title') || undefined,
    videoThumbnail: params.get('thumb') || undefined,
    videoProvider: params.get('provider') || undefined,
    sectionTitle: params.get('section') || undefined,
    tagId: params.get('tagId') || undefined,
    tagName: params.get('tagName') || undefined,
  }
}

